/**
 * 三检记录表功能灰度配置。
 *
 * KV key: web_three_inspection_report
 * value 示例：
 *   {"enable":true,"groupIds":["222629599"]}
 *
 * groupIds 为空时表示全量开放；配置缺失或格式错误时默认关闭。
 * 团队名单只维护在远程 KV，前端不保留硬编码白名单。
 */

export const THREE_INSPECTION_CONFIG_KEY = 'web_three_inspection_report'

export interface ThreeInspectionAccessConfig {
  enable: boolean
  groupIds?: string[]
}

export function parseThreeInspectionAccessConfig(
  rawValue: string | undefined | null
): ThreeInspectionAccessConfig | null {
  if (!rawValue) return null

  try {
    const parsed = JSON.parse(rawValue)
    const enable =
      typeof parsed?.enable === 'boolean'
        ? parsed.enable
        : typeof parsed?.enabled === 'boolean'
          ? parsed.enabled
          : undefined
    if (enable === undefined) return null
    if (parsed.groupIds !== undefined && !Array.isArray(parsed.groupIds)) {
      return null
    }

    return {
      enable,
      groupIds: parsed.groupIds?.map((id: string | number) => String(id))
    }
  } catch (_error) {
    return null
  }
}

export function canUseThreeInspectionReport(
  rawValue: string | undefined | null,
  inviteId: string | number | undefined | null,
  groupId: string | number | undefined | null
): boolean {
  const config = parseThreeInspectionAccessConfig(rawValue)
  if (!config?.enable) return false
  if (!config.groupIds?.length) return true

  const currentGroupIds = [inviteId, groupId]
    .filter((id): id is string | number => id !== undefined && id !== null)
    .map(String)

  return currentGroupIds.some((id) => config.groupIds?.includes(id))
}
